/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SiegeSocialChefEntrepriseGridDto } from './SiegeSocialChefEntrepriseGridDto';
import {
    SiegeSocialChefEntrepriseGridDtoFromJSON,
    SiegeSocialChefEntrepriseGridDtoFromJSONTyped,
    SiegeSocialChefEntrepriseGridDtoToJSON,
} from './SiegeSocialChefEntrepriseGridDto';

/**
 * 
 * @export
 * @interface SiegeSocialChefEntrepriseGridDtoPaginatedResults
 */
export interface SiegeSocialChefEntrepriseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialChefEntrepriseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SiegeSocialChefEntrepriseGridDto>}
     * @memberof SiegeSocialChefEntrepriseGridDtoPaginatedResults
     */
    results?: Array<SiegeSocialChefEntrepriseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SiegeSocialChefEntrepriseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SiegeSocialChefEntrepriseGridDtoPaginatedResults interface.
 */
export function instanceOfSiegeSocialChefEntrepriseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeSocialChefEntrepriseGridDtoPaginatedResultsFromJSON(json: any): SiegeSocialChefEntrepriseGridDtoPaginatedResults {
    return SiegeSocialChefEntrepriseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SiegeSocialChefEntrepriseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeSocialChefEntrepriseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SiegeSocialChefEntrepriseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SiegeSocialChefEntrepriseGridDtoPaginatedResultsToJSON(value?: SiegeSocialChefEntrepriseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SiegeSocialChefEntrepriseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

